module.exports = __webpack_public_path__ + "static/media/medial-flexion-up.ccf065c6.png";